import type { CSSProperties } from 'react'

/**
 * The brand asset is a single stacked composite of three panels:
 * 0 = modelo con rizos, 1 = mockup del ebook, 2 = antes / después del cabello.
 * These helpers crop one panel out of it for use as a background.
 */
export const BRAND_IMAGE =
  'https://cdn.magicpatterns.com/uploads/pHiMmwbZLVx616DCWakqRQ/heylloyd-image-1788916305964.png'

export type PanelIndex = 0 | 1 | 2

export function panelStyle(index: PanelIndex, horizontal = 'center'): CSSProperties {
  return {
    backgroundImage: `url(${BRAND_IMAGE})`,
    backgroundSize: '100% 300%',
    backgroundPosition: `${horizontal} ${index * 50}%`,
    backgroundRepeat: 'no-repeat',
  }
}
